<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Youtube URL',
              modelPath: [this, 'form', 'youtube_url'],
              required: true
            }),
            new fields.Switch({
              label: 'Play button at start',
              modelPath: [this, 'form', 'play_button_at_start']
            })
          ]
        }
      ]
    }
  }
}
</script>
